import styled from "styled-components";
import type { MergeElementProps } from "../../../utils/MergeElementProps";

type Props = MergeElementProps<
  "div",
  {
    className?: string;
    noBoxShadow?: boolean;
  }
> & {
  dataTestid?: string;
};

export function Drawer2Actions({
  noBoxShadow,
  children,
  dataTestid,
  ...rest
}: Props) {
  return (
    <Container noBoxShadow={noBoxShadow} {...rest} data-testid={dataTestid}>
      {children}
    </Container>
  );
}

const Container = styled.div<{ noBoxShadow: boolean | undefined }>`
  display: flex;
  margin-top: auto;
  // Vertical spacing is actually 16px, but we use 8px here so we
  // can add it up across the compound components that are used.
  padding: 8px 16px;
  box-shadow: ${(props) =>
    props.noBoxShadow ? null : "0px 0px 8px rgba(0, 0, 0, 0.2)"};
`;
